<router-outlet />

<app-auth-modal
  [visible]="sessionState.isLocked()"
  [sessionExpiry]="true"
  (authSuccess)="sessionState.onAuthRestored()"
  (dismissed)="sessionState.onAuthDismissed()"
  (visibleChange)="$event || sessionState.onAuthDismissed()" />

@if (undoSvc.pending(); as label) {
  <div class="undo-toast">
    <span>{{ label }} deleted</span>
    <button (click)="undoSvc.undo()">Undo</button>
  </div>
}
